import _ from 'lodash';

const pictureIsValid = (placeholder, item) =>
  item.color === placeholder.color && item.category === placeholder.category;

const wordIsValid = (placeholder, item) =>
  item.first_letter === placeholder.first_letter &&
  item.category === placeholder.category;

// determines if selected item completes the grid
export function itemIsCorrect(setType, placeholder, item) {
  switch (setType) {
    case 'picture_set':
      return pictureIsValid(placeholder, item);
    case 'word_set':
      return wordIsValid(placeholder, item);
    default:
      return false;
  }
}
// returns attribute which make items grid incorrect
export function retrieveMismatchedAttribute(setType, gridItems, selectedItem) {
  const items = [...gridItems, selectedItem];

  const attributes = retrieveAttributeList(setType);

  const groupedItems = attributes.map((attribute) => {
    const counts = _.countBy(
      items,
      item => item[attribute] === selectedItem[attribute],
    );

    return { attribute, counts };
  });

  const mismatchItems = groupedItems.find(group => group.counts.true > 2);

  return mismatchItems.attribute;
}

// returns item attributes list by current data set type
export function retrieveAttributeList(setType) {
  return setType === 'picture_set'
    ? ['color', 'category']
    : ['first_letter', 'category'];
}
